import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = ({invoiceId}: {invoiceId?: string} = {}) => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <RecordsTable invoiceId={invoiceId}/>
        </SimplePageLayout>
    );
};
